import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "modalRoot",
    "modal"
  ]

  static values = {
    add: String,
    animate: Boolean,
    remove: String,
  }

  connect() {
    this.modalTarget.classList.add("translate-x-full")

    if (this.hasModalRootTarget){
      this.modalRootTarget.focus({ preventScroll: true })
      this.modalRootTarget.addEventListener('keydown', (e) => {
        if (e.code !== 'Escape') return
        this.closeModal()
      })
    }

    setTimeout(() => {
      this.modalTarget.classList.remove("translate-x-full")
      this.modalTarget.classList.add(
        "transform",
        "transition",
        "ease-in-out",
        "duration-300",
        "sm:duration-500",
        "translate-x-0"
      )
    }, 50)

    this.element.addEventListener('turbo:submit-end', (e) => {
      if (e.detail.success) {
        this.closeModal()
      }
    })
  }

  closeModal(){
    this.slideOut()
    this.remove()
  }

  slideOut() {
    this.modalTarget.classList.remove("translate-x-0")
    this.modalTarget.classList.add(
      "transform",
      "transition",
      "ease-in-out",
      "duration-300",
      "sm:duration-500",
      "translate-x-full"
    )
  }

  remove(e) {
    e?.preventDefault()

    if (this.hasAnimateValue && this.animateValue) {
      this.modalRootTargets.forEach((modalRoot) => {
        if (this.hasRemoveValue) {
          this.removeValue.split(" ").forEach((klass) => {
            modalRoot.classList.remove(klass);
          })
        } else {
          modalRoot.classList.remove("animate-fade-in")
        }
        if (this.hasAddValue) {
          this.addValue.split(" ").forEach((klass) => {
            modalRoot.classList.add(klass)
          })
        } else {
          modalRoot.classList.add("animate-fade-out")
        }
      });
    }

    this.modalRootTargets.forEach((modalRoot) => {
      setTimeout(() => modalRoot.remove(), 300)
    })
  }
}
